import { useEffect, useState } from "react";
import { Asset } from "../../../../../models/asset";
import { IContractDetailsVolksEssential } from "../../../../../models/volksPlanEssential";
import { getAssetByChassis } from "../../../../../utils/assetUtils";
import useAssets from "../../../../../hooks/useAssets";
import { fetchMaintenance } from "../../../../../api/fetchMaintenance";
import { fetchVolksEssentialsContractDetails } from "../../../../../api/fetchContractDetails";

export const useOccurrenceVehicleSummaryCard = (chassis: string) => {
    const { allAssets } = useAssets();

    const [customMaintenanceGroupLoading, setCustomMaintenanceGroupLoading] = useState(false);
    const [customMaintenanceGroup, setCustomMaintenanceGroup] = useState<string | null>(null);
    const [customMaintenanceGroupSaved, setCustomMaintenanceGroupSaved] = useState(false);

    const [volksEssentialsPlan, setVolksEssentialsPlan] = useState<IContractDetailsVolksEssential | null>(null);

    // Vehicle data
    const [maintenanceGroup, setMaintenanceGroup] = useState<string>();
    const [maintenanceGroupLoaded, setMaintenanceGroupLoaded] = useState(false);

    const fetchAssetData = async (asset: Asset) => {
        const [assets, _] = await fetchMaintenance([{ id: asset.id, identification: asset.chassis, name: asset.name }]);
        const assetFound = assets.length > 0 ? assets[0] : null;
        if (assetFound && (assetFound.groupName !== '-')) setMaintenanceGroup(assetFound.group);
        else setMaintenanceGroup(undefined);
        setMaintenanceGroupLoaded(true);
    }

    useEffect(() => {
        const getVolksEssentialsPlan = async () => {
            if (chassis.length < 17) return;
            const volksEssentialsPlan = await fetchVolksEssentialsContractDetails({ chassis });
            if(volksEssentialsPlan) setVolksEssentialsPlan(volksEssentialsPlan);
        }
        
        const asset = getAssetByChassis(allAssets, chassis);
        if(asset) fetchAssetData(asset);
        else setMaintenanceGroupLoaded(true);
        
        getVolksEssentialsPlan();
    }, [chassis]);

    return {
        maintenanceGroup,
        maintenanceGroupLoaded,
        customMaintenanceGroup,
        customMaintenanceGroupLoading,
        customMaintenanceGroupSaved,
        volksEssentialsPlan,
        setCustomMaintenanceGroup,
        setCustomMaintenanceGroupLoading,
        setCustomMaintenanceGroupSaved,
    }
}